import WebApp from '@twa-dev/sdk'
import { useEffect, useRef } from 'react'

/**
 * Управляет нативной кнопкой «Назад» Telegram Mini App (BackButton API).
 *
 * - enabled=true  → BackButton.show() + регистрирует onBack как обработчик.
 * - enabled=false → BackButton.hide() (обработчик не регистрируется).
 * - При unmount / изменении enabled  → offClick + hide.
 *
 * Callback стабилизирован через ref, поэтому создавать inline-функцию
 * в вызывающем компоненте безопасно — эффект не перезапускается при
 * каждом рендере.
 */
export function useBackButton(enabled: boolean, onBack: () => void): void {
  // Ref гарантирует, что мы всегда вызываем свежую версию callback,
  // не пересоздавая обработчик при каждом рендере.
  const callbackRef = useRef(onBack)
  callbackRef.current = onBack

  useEffect(() => {
    if (!enabled) {
      WebApp.BackButton.hide()
      return
    }

    const handler = () => callbackRef.current()

    WebApp.BackButton.show()
    WebApp.BackButton.onClick(handler)

    return () => {
      WebApp.BackButton.offClick(handler)
      WebApp.BackButton.hide()
    }
  }, [enabled])
}
